import { render } from "./AdminRoutes.vue?vue&type=template&id=6e2e5d97&scoped=true"
import script from "./AdminRoutes.vue?vue&type=script&lang=js"
export * from "./AdminRoutes.vue?vue&type=script&lang=js"

import "./AdminRoutes.vue?vue&type=style&index=0&id=6e2e5d97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2e5d97"]])

export default __exports__